'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}(); // Libs


var _dateFns = require('date-fns');

var _dualDateDigit = require('./dualDateDigit.date');

var _dualDateDigit2 = _interopRequireDefault(_dualDateDigit);

var _hourPart = require('./hourPart.date');

var hourPart = _interopRequireWildcard(_hourPart);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var create = function create() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (!str) return {
    hour: null,
    minutes: null,
    dayPart: null
  };

  var _str$split = str.split(':'),
      _str$split2 = _slicedToArray(_str$split, 2),
      rawHour = _str$split2[0],
      minutes = _str$split2[1];

  var _hourPart$dec = hourPart.dec(rawHour),
      hour = _hourPart$dec.hour,
      dayPart = _hourPart$dec.dayPart;

  var data = {
    hour: hour,
    minutes: minutes || null,
    dayPart: dayPart
  };
  if (data.hour !== null) data.hour = (0, _dualDateDigit2.default)(data.hour);
  return data;
};

var revert = function revert(_ref) {
  var hour = _ref.hour,
      minutes = _ref.minutes,
      dayPart = _ref.dayPart;
  return (0, _dualDateDigit2.default)(hourPart.enc(hour, dayPart)) + ':' + minutes + ':00';
};

var toDate = function toDate() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hour = _ref2.hour,
      hour = _ref2$hour === undefined ? null : _ref2$hour,
      _ref2$minutes = _ref2.minutes,
      minutes = _ref2$minutes === undefined ? null : _ref2$minutes,
      _ref2$dayPart = _ref2.dayPart,
      dayPart = _ref2$dayPart === undefined ? null : _ref2$dayPart;

  return !hour || !minutes || !dayPart ? null : new Date((0, _dateFns.getYear)(new Date()), (0, _dateFns.getMonth)(new Date()), (0, _dateFns.getDate)(new Date()), hourPart.enc(hour, dayPart), minutes);
};

exports.default = {
  type: 'time',
  create: create,
  revert: revert,
  toDate: toDate
};